const getBusinessId = (business) =>
  business?.businessId || business?.id || business?.businessID || "";

const getBusinessName = (business) =>
  business?.businessName || business?.name || business?.business || "";

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const buildBusinessAliases = (businesses, scopedBusinessId) => {
  const ids = [
    ...new Set(
      [...businesses.map(getBusinessId), scopedBusinessId]
        .filter(Boolean)
        .map(String)
    ),
  ].sort();

  return Object.fromEntries(
    ids.map((id, index) => [id, `Hotel ${index + 1}`])
  );
};

export const getBusinessDisplayName = (business, aliases, presentationMode) => {
  if (!presentationMode) {
    return getBusinessName(business);
  }

  return aliases[String(getBusinessId(business))] || "Hotel";
};

export const replaceBusinessNames = (items, businesses, aliases) => {
  const names = new Map();

  businesses.forEach((business) => {
    const alias = aliases[String(getBusinessId(business))];
    const name = String(getBusinessName(business)).trim();
    if (alias && name) {
      names.set(name.toLowerCase(), alias);
    }
  });

  if (!names.size) {
    return items;
  }

  const pattern = new RegExp(
    [...names.keys()].sort((a, b) => b.length - a.length).map(escapeRegExp).join("|"),
    "gi"
  );

  return (Array.isArray(items) ? items : []).map((item) =>
    typeof item === "string"
      ? item.replace(pattern, (match) => names.get(match.toLowerCase()))
      : item
  );
};

export const replaceReferralLinks = (links) =>
  (Array.isArray(links) ? links : []).map((link, index) => {
    const dummyUrl = `https://example.com/referral/${index + 1}`;
    return { ...link, name: dummyUrl, link: dummyUrl };
  });
